module.exports = __webpack_public_path__ + "static/media/varie6e.c7613859.jpg";